export const WHITE = '#FFFFFF';

/* VIG ZDROWIE */
export const PRIMARY_RED = '#FE4B49';
export const SECONDARY_RED = '#D94A47';
export const LIGHT_PINK = '#FFB7B6';

export const VZ_BLACK = "#000000";
export const ACCENT_GREY_1 = "#3C3C3B";
export const ACCENT_GREY_2 = "#878787";
export const ACCENT_GREY_3 = "#C6C6C6";
export const VZ_LIGHT_GREY = "#F7F7F7";

export const SUCCESS_FILL = "#008675";

/* Deprecated */
export const MAGENTA = '#FF007F';
export const TEXT_PRIMARY = '#212121';
export const INPUT_TEXT_PRIMARY = '#3C3C3B';
export const PRIMARY = '#212121';
export const TEXT_SECONDARY = '#666666';
export const BACKGROUND_PRIMARY = '#E5E5E5';
export const BACKGROUND_SECONDARY = '#EEEEEE';
export const GRAY = '#767676';
export const LIGHT_GRAY = '#DEDEDE';
export const LIGHT_GRAY_BORDER = '#E0E0E0';
export const LIGHT_DISABLED = '#9E9E9E';
export const CONVERSATION_BACKGROUND = '#4A4A4A';
export const BLACK = '#000000';
export const GREEN = '#01B810';
export const RED = '#D32F2F';
export const ORANGE = '#FFAB00';